import { ColonistMembershipProduct } from '../../../../shared/store/ColonistMembershipProduct.ts';
import { DiscordAnnualMembershipPrices } from '../../../../shared/store/StoreConstants.ts';
import { setElementInnerText } from '../ui_utils/DomUtils.ts';
import { UIStoreMembershipTabsController } from './UIStoreMembershipTabsController.ts';
import { ColonistMembershipType } from '@colonist/types';
export class UIDStoreMembershipTabsController extends UIStoreMembershipTabsController {
    setAnnualTabText() {
        const nonDiscountedAnnualPrice = ColonistMembershipProduct.getMembershipProduct(ColonistMembershipType.PremiumMonthly).price * 12;
        const discount = Math.round((1 - DiscordAnnualMembershipPrices.PREMIUM / nonDiscountedAnnualPrice) * 100);
        setElementInnerText(this.annualTab, {
            key: 'strings:storePage.membership.frequency.annual',
            options: {
                context: 'store',
                discount: discount
            }
        });
    }
    constructor(storeState, monthlyTab, annualTab){
        super(storeState, monthlyTab, annualTab);
        this.setAnnualTabText();
    }
}
